export class Exercise {
    public _id: string;
    public asset: any;
    public countdown: number;
    public endConditionType: string;
    public endConditionValue: number;
    public label: string;
    public specifications: string[];
    public type: string;

    constructor() {}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/exercise.ts